/**
 * The studio viewer for this session (cowork/clientFeatures.ts studioViewerFrom): staff, a client team with its open
 * studios, the old show_cowork rule (with a positive staff sign) when /v1/me never answered, or loading.
 */
import { useAuth } from '@/contexts/AuthContext';
import { beatlyStaffHint, studioPageState, studioViewerFrom, type StudioPageState, type StudioViewer } from '@/cowork/clientFeatures';
import { useCoworkMe } from './useCoworkMe';

/** api-v2 `show_cowork`, plus the dev-only VITE_COWORK_FORCE override (as App.tsx reads it). */
export function useShowCowork(): boolean {
  const { user } = useAuth();
  return user?.show_cowork === true || (import.meta.env.DEV && import.meta.env.VITE_COWORK_FORCE === 'true' && !!user);
}

export function useStudioViewer(): StudioViewer {
  const me = useCoworkMe();
  const showCowork = useShowCowork();
  const { user } = useAuth();
  return studioViewerFrom(me.data, { pending: me.isPending, failed: me.isError, showCowork, staffHint: beatlyStaffHint(user) });
}

/** What this studio page draws for this session: open, loading, closed, paused (or not-studio). */
export function useStudioPageState(page: string): StudioPageState {
  return studioPageState(page, useStudioViewer());
}
